import { GET_MUNDIAL_TEAMS } from '../types/teams.types';



export default (state = [], action) => {
  switch (action.type) {
    case GET_MUNDIAL_TEAMS:
      return [
        ...action.payload
      ]

    default:
      return state;
  }
};
